var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"unconfiguredDevices",attrs:{"title":"Central Device Management (Gekko)","sub-title":"Unconfigured Devices","icon":"tablet-alt"}},[_c('UnconfiguredDevicesDisplay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }